export const toggleToolArea = () =>
	({
		type : 'TOGGLE_TOOL_AREA'
	});

export const openToolArea = () =>
	({
		type : 'OPEN_TOOL_AREA'
	});

export const closeToolArea = () =>
	({
		type : 'CLOSE_TOOL_AREA'
	});

export const setToolTab = (toolTab) =>
	({
		type    : 'SET_TOOL_TAB',
		payload : { toolTab }
	});

export const setUserTabs = (usersTab) =>
	({
		type    : 'SET_USERS_TAB',
		payload : { usersTab }
	});

export const setHelpTab = (helpTab) =>
	({
		type    : 'SET_HELP_TAB',
		payload : { helpTab }
	});

export const templateScreenShare = (templateIsScreenShare) =>
	({
		type    : 'TEMPLATE_HIDE_SCREENSHARE',
		payload : { templateIsScreenShare }
	});

export const tempateWhiteBoard = (templateIsWhiteboard) =>
	({
		type    : 'TEMPLATE_HIDE_WHITEBOARD',
		payload : { templateIsWhiteboard }
	});

export const templateChat = (templateIsChat) =>
	({
		type    : 'TEMPLATE_HIDE_CHAT',
		payload : { templateIsChat }
	});

export const templateAddionalCam = (templateIsAddCam) =>
	({
		type    : 'TEMPLATE_HIDE_ADDIONAL_CAM',
		payload : { templateIsAddCam }
	});

export const templateFileShare = (templateIsFileShare) =>
	({
		type    : 'TEMPLATE_HIDE_FILESHARE',
		payload : { templateIsFileShare }
	});
export const templateCloudRecording = (templateIsCloudRecording) =>
	({
		type    : 'TEMPLATE_CLOUD_RECORDING',
		payload : { templateIsCloudRecording }
	});
export const templateHideNWPart = (templateHidePart) =>
	({
		type    : 'TEMPLATE_HIDE_PARTICIPANTS_NV',
		payload : { templateHidePart }
	});

export const templateNotificationSoundOnOff = (templateNotificationSound) =>
	({
		type    : 'TEMPLATE_NOTIFICATIONS_SOUND',
		payload : { templateNotificationSound }
	});

export const tempateNotificationOnOff = (templateNotification) =>
	({
		type    : 'TEMPLATE_NOTIFICATION_OFF',
		payload : { templateNotification }
	});
export const breakOutRoomOnOff = (templateBreakOutRoom) =>
	({
		type   	: 'BREAKOUT_ROOM_OFF',
		payload	: { templateBreakOutRoom }
	});
export const lockRoomOnOff = (templateLockRoom) =>
	({
		type   	: 'LOCK_ROOM_OFF',
		payload	: { templateLockRoom }
	});
export const sendChatOnOff = (templateChatMsgs) =>
	({
		type    : 'SEND_CHAT_MSGS',
		payload : { templateChatMsgs }
	});
export const sendFilesOnOff = (templateSendFiles) =>
	({
		type    : 'SEND_FILES',
		payload : { templateSendFiles }
	});
export const microphoneAccessOnOff = (templateMicrophoneAccess) =>
	({
		type    : 'MICROPHONE_ACCESS',
		payload : { templateMicrophoneAccess }
	});
export const videoAccessOnOff = (templateVideoAccess) =>
	({
		type    : 'VIDEO_ACCESS',
		payload : { templateVideoAccess }
	});
export const exitUrl = (templateExitUrl) =>
	({
		type    : 'EXIT_URL',
		payload : { templateExitUrl }
	});
export const waitingRoomUrlStatusOnOff = (templateWaitingRoomUrlStatus) =>
	({
		type    : 'WAITING_ROOM_URL_STATUS',
		payload : { templateWaitingRoomUrlStatus }
	});
export const waitingRoomUrl = (templateWaitingRoomUrl) =>
	({
		type    : 'WAITING_ROOM_URL',
		payload : { templateWaitingRoomUrl }
	});
export const noRecordingEnabled = (templateNoRecording) =>
	({
		type    : 'NO_RECORDING',
		payload : { templateNoRecording }
	});
export const brandingImage = (brandingImageLogo) =>
	({
		type    : 'BRANDING_IMAGE',
		payload : { brandingImageLogo }
	});

export const setPollingTabs = (pollingTab) =>
	({
		type    : 'SELECTED_TAB',
		payload : { pollingTab }
	});
export const handleChatEmojis = (openChatEmoji) =>
	({
		type    : 'HANDLE_OPEN_CHAT_EMOJI',
		payload : { openChatEmoji }
	});
export const setChatEmoji = (selectedChatEmoji) =>
	({
		type    : 'SELECTED_CHAT_EMOJI',
		payload : { selectedChatEmoji }
	});
export const handleEmojis = (emojiObj) =>
	({
		type    : 'SELECTED_ANIME_EMOJI',
		payload : { emojiObj }
	});
export const removeEmojis = () =>
	({
		type	: 'REMOVE_ANIME_EMOJI'
	});
export const handlePollings = (pollingData) =>
	({
		type   	: 'SET_POLLINGS_LIST',
		payload : { pollingData }
	});
export const handlePollingDialogue = (isPollOpen) =>
	({
		type   	: 'SET_POLL_DIALOGUE',
		payload : { isPollOpen }
	});
export const handlePeerOpenPoll = (poll) =>
	({
		type   	: 'SET_PEER_OPEN_POLL_DIALOGUE',
		payload : { poll }
	});
// export const handleCurrentPolling = (pollingData) =>
// 	({
// 		type   	: 'SET_CURRENT_POLLING',
// 		payload : { pollingData }
// 	});
export const handleResultPollObj = (poll) =>
	({
		type   	: 'SET_CURRENT_RESULT_POLL',
		payload : { poll }
	});
export const peerPollSubmitList = (pollSubmitData) =>
	({
		type   	: 'SET_PEER_POLL_SUBMIT_LIST',
		payload : { pollSubmitData }
	});
export const pollSubmitList = (pollId, pollSubmitData) =>
	({
		type   	: 'UPDATE_POLL_SUBMIT_LIST',
		payload : { pollId, pollSubmitData }
	});
export const setResultObj = (poll) =>
	({
		type    : 'SET_RESULT_OBJ',
		payload : { poll }
	});
export const modifyingPoll = (poll) =>
	({
		type    : 'SET_MODIFY_POLL',
		payload : { poll }
	});
export const hostHandleControls = (hostControlsObj) =>
	({
		type    : 'HANDLE_HOST_CONTROLS',
		payload : { hostControlsObj }
	});
export const setHostControls = (hostControlsObj) =>
	({
		type    : 'SET_HOST_CONTROLS',
		payload : { hostControlsObj }
	});
export const moderatorRequestPeerVideoOrAudio = (requestObj) =>
	({
		type    : 'SET_HOST_REQUEST_PEER_VIDEO_OR_AUDIO',
		payload : { requestObj }
	});

export const setShowParticipantActions = (showParticipantActions) =>
	({
		type    : 'SHOW_PARTICIPANT_ACTIONS',
		payload : { showParticipantActions }
	});
export const setPollingActive = (pollingActive) =>
	({
		type    : 'SET_POLLING_ACTIVE',
		payload : { pollingActive }
	});
export const setParticipants = (participantsTab) =>
	({
		type    : 'SET_PARTICIPANTS_TAB',
		payload : { participantsTab }
	});